export default __webpack_public_path__ + "static/media/Ocho Aok.2ea02520.png";